export default __webpack_public_path__ + "static/media/blank.907fed53.png";